import InnerComponent from '@Components/Inventory/PreviewPo';
import orgContainer from '@Components/AppContainer';

const PreviewPo = () => ((orgContainer(InnerComponent)));
export default PreviewPo;
